













import getCraftPages from '~/queries/craft-pages.gql'
import pageMixin from '@bkwld/cloak/mixins/page'
import brandLogo from 'library/assets/images/logos/brand/brand-desktop-active.svg'
import {
	makeJsonLdOrganizationTag
	makeJsonLdSearchTag
} from 'library/services/json-ld'

export default
	name: 'Tower'

	mixins: [ pageMixin ]

	head: -> {
		...@buildHead()
		...(unless @$route.path == '/' then {} else
			script: [
				makeJsonLdOrganizationTag logo: process.env.URL + brandLogo
				makeJsonLdSearchTag()
			]
		)
	}

	data: ->
		bodyHeightOffset: 0

	watch:
		'$store.state.layout.bodyOffset': (value) ->
			@bodyHeightOffset = value.offset


	# Reset the global element visibility before leaving;
	# if navigating to another page, this will update with that tower's data
	# Use route guard instead of beforeDestroy to help with "back" navigation
	beforeRouteLeave: (to, from, next) ->
		@$store.commit 'layout/setGlobalElementVisibility', false
		next()

	# Get Tower data
	asyncData: ({ app, store, params }) ->

		# Get data
		[ page ] = await app.$craft.getEntries
			query: getCraftPages
			variables:
				section: 'towers'
				type: 'towers'
				uri: params.tower || '__home__'
		return app.$notFound() unless page

		# set the global elements as hidden
		# if the tower tells us to
		store.commit 'layout/setGlobalElementVisibility', page.disableGlobalElements

		# Set data
		return { page }

